var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Kaiju Payouts")]),_c('ListFirestore',{attrs:{"item-name":"KaijuPayoutItem","get-collection":_vm.getKaijuPayouts,"order-list":_vm.orderList},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var payout = ref.item;
return [_c('KaijuPayoutItem',{attrs:{"payout-data":payout}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }